import "../pages/CheckIn.css";
import React, { useState, useEffect, useRef } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import {
  Box,
  OutlinedInput,
  Select,
  MenuItem,
  Chip,
  Stack,
  Paper,
  Typography,
  Button,
} from "@mui/material";
import { DataGrid,GridToolbar } from "@mui/x-data-grid";
import { useSnackbar } from "notistack";
import { GetDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useReactToPrint } from "react-to-print";
import { TableChart, PictureAsPdf, Print } from "@mui/icons-material";
import ExcelIcon from "../images/IconExcel";

const columns = [
  { field: "id", headerName: "ID", width: 60 },
  { field: "Name", headerName: "Name", width: 140 },
  // { field: "Pass_LName", headerName: "Last Name", width: 140 },
  { field: "Pass_No", headerName: "Passport", width: 130 },
  { field: "Prese_Name", headerName: "Agency Type", width: 130 },
    { field: "Room_Number", headerName: "Room", width: 80 },
  { field: "Night_No", headerName: "Nights", width: 80 },
  { field: "Reserv_Account", headerName: "Net Price $", width: 100 },
  { field: "Reserv_Rate", headerName: "Rate", width: 100 },
  { field: "Reserv_Gel", headerName: "Net Price ₾", width: 100 },
];

const paginationModel = { page: 0, pageSize: 10 };

export default function AgencyReport() {
  const [data, setData] = useState([]);
  const [Prese_Id, setPrese_Id] = useState("");
  const [PresentTypeData, setPresentTypeData] = useState([]);
  const [From_Date, setFrom_Date] = useState(new DateObject());
  const [To_Date, setTo_Date] = useState(new DateObject().add(7, "day"));
  const { enqueueSnackbar } = useSnackbar();
  const gridRef = useRef();

  useEffect(() => {
    getPresentType();
  }, []);

  const getData = async () => {
    let uparams = new URLSearchParams();
    uparams.append("From_Date", From_Date);
    uparams.append("To_Date", To_Date);
    uparams.append("prese_Id", Prese_Id);

    let res = await GetDataPromise(
      `${apiMain}/api/v1/reservation/selectpreseddate?${uparams}`,
      true
    );
    let parsed = JSON.parse(res);
    if (parsed.status === "success") {
      setData(parsed.data);
      enqueueSnackbar("Report loaded successfully!", { variant: "success" });
    } else {
      enqueueSnackbar("Error loading data", { variant: "error" });
    }
  };

  const getPresentType = async () => {
    let res = await GetDataPromise(`${apiMain}/api/v1/presents`, true);
    let parsed = JSON.parse(res);
    if (parsed.status === "success") setPresentTypeData(parsed.data);
  };

  // 🧾 خروجی به Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, `AgencyReport_${new Date().toISOString()}.xlsx`);
  };

  // 🧾 خروجی به PDF
  const exportToPDF = () => {
    if (!data || data.length === 0) {
      enqueueSnackbar("No data to export", { variant: "warning" });
      return;
    }

    const doc = new jsPDF("p", "pt", "a4");
    doc.setFontSize(16);
    doc.text("Agency Report", 40, 30);
    doc.setFontSize(10);
    doc.text(
      `From: ${From_Date.format("YYYY-MM-DD")}  To: ${To_Date.format(
        "YYYY-MM-DD"
      )}`,
      40,
      45
    );

    const head = [["Name", "Last Name", "Passport", "Room", "Nights", "Account"]];
    const body = data.map((d) => [
      d.Pass_FName || "",
      // d.Pass_LName || "",
      d.Pass_No || "",
      d.Room_Number || "",
      d.Night_No || "",
      d.Reserv_Account || "",
    ]);

    autoTable(doc, {
      head,
      body,
      startY: 60,
      theme: "striped",
      headStyles: { fillColor: [22, 160, 133], textColor: 255 },
      styles: { fontSize: 9, cellPadding: 3 },
    });

    doc.save(`AgencyReport_${new Date().toISOString()}.pdf`);
  };

  // 🖨 چاپ مستقیم
  const handlePrint = useReactToPrint({
    content: () => gridRef.current,
    documentTitle: "Agency Report",
  });
  const totalPrice = data?.reduce((acc, row) => acc + (row.Reserv_Total || 0), 0) || 0;

  return (
    <Box sx={{ p: 2 }}>
      {/* 🔷 فیلترها و کنترل‌ها */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 2,
          p: 2,
          mb: 3,
          backgroundColor: "#fdfdfd",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 1,
       
        }}
      >
        {/* <Typography
          variant="h6"
          sx={{ mb: 1, color: "#2c3e50", fontWeight: "bold" }}
        >
          Agency Report Filter
        </Typography> */}
  
        <Stack
  direction="row"
  spacing={1} // ← فاصله کل Stack کمتر شد
  alignItems="center"
  sx={{ mb: 1, width:'800px',height:'30px'}}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <label style={{width:'60px'}}> Type:</label>
  <Select
    value={Prese_Id}
    onChange={(e) => setPrese_Id(e.target.value)}
    input={<OutlinedInput />}
    sx={{ width: 180, backgroundColor: "#fff" ,height:'30px'}}
  >
    <MenuItem value="0">
      <em>All</em>
    </MenuItem>
    {PresentTypeData.map((dat) => (
      <MenuItem key={dat.value} value={dat.value}>
        {dat.label}
      </MenuItem>
    ))}
  </Select>
</Box>

  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <label>From:</label>
    <DatePicker
      value={From_Date}
      onChange={setFrom_Date}
      style={{ height: "35px" ,width:'90px'}}
    />
  </Box>

  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <label style={{marginLeft:'20px'}}>To:</label>
    <DatePicker
      value={To_Date}
      onChange={setTo_Date}
      style={{ height: "35px" ,width:'90px'}}
    />
  </Box>

  <Chip
    label="Run Report"
    onClick={getData}
    color="primary"
    sx={{
      cursor: "pointer",
      fontWeight: "bold",
      backgroundColor: "#16a085",
      color: "#fff",
    }}
  />
{/* </Stack> */}

<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <Button
    variant="contained"
    color="success"
    onClick={exportToExcel}
    sx={{ minWidth: 50, height: 35 }}
  >
     <ExcelIcon />
   
  </Button>
  </Box>
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <Button
    variant="contained"
    color="error"
    onClick={exportToPDF}
    sx={{ minWidth: 50, height: 35 }}
  >
    <PictureAsPdf />
  </Button>
  </Box>
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <Button
    variant="contained"
    sx={{ backgroundColor: "#34495e", minWidth: 50, height: 35 }}
    onClick={handlePrint}
  >
    <Print />
  </Button>
  </Box>
  </Stack>
      </Paper>
  
      {/* 🔶 جدول داده‌ها */}
      <Paper
  elevation={4}
  sx={{
    marginTop:0,
    height: 300, // ارتفاع ثابت یا هر مقدار دلخواه
    borderRadius: 3,
  //  overflow: "auto", // اسکرول فعال برای فضای داخلی
    "& .MuiDataGrid-root": {
      border: "none",
      fontFamily: "Roboto, Vazirmatn, sans-serif",
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#16a085",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#16a085 !important",
      color: "#fff !important",
      fontWeight: "bold",
      fontSize: "12px",
      textAlign: "center",
      borderRight: "1px solid rgba(255,255,255,0.2)", // اختیاری برای زیبایی
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "1.4em",
    },
    "& .MuiDataGrid-cell": {
      color: "#2c3e50",
      fontSize: "12px",
      fontWeight: "bold",   //  ← پررنگ شدن داده‌ها
      borderBottom: "1px solid #ecf0f1",
    },
    "& .MuiDataGrid-row:nth-of-type(odd)": {
      backgroundColor: "#f9f9f9",
    },
    "& .MuiDataGrid-row:nth-of-type(even)": {
      backgroundColor: "#ffffff",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#e0f2f1",
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "#f4f6f6",
      borderTop: "2px solid #d5dbdb",
    },
  }}
>
  <DataGrid
    rows={data}
    columns={columns}
    disableColumnMenu={false} // ← منو را فعال کن تا آیکون فیلتر ظاهر شود
    disableColumnSelector
    disableDensitySelector
    hideFooterSelectedRowCount
    filterMode="client" // ← فیلتر سمت کلاینت
    disableColumnFilter={false} // ← مطمئن شو فیلتر غیرفعال نیست
    // slots={{
    //   toolbar: GridToolbar, // ← نوار ابزار شامل فیلتر، جستجو و ...
    // }}
    slotProps={{
      toolbar: {
        showQuickFilter: true, // ← فیلتر سریع بالای جدول
        quickFilterProps: { debounceMs: 500 },
      },
    }}
    hideFooter // ← فوتر پیش‌فرض را مخفی می‌کند
    rowHeight={32} // ارتفاع ردیف‌ها
    headerHeight={36} // ارتفاع هدرها
    pagination={false} // غیرفعال کردن صفحه‌بندی
    autoHeight={false} // غیرفعال کردن ارتفاع خودکار
  />
{/* {  if (data!==undefined) */}


<Box
  sx={{
    display: "flex",
    justifyContent: "flex-end",
    gap: 2, // فاصله بین عناصر
    p: 1,
    color: "#2c3e50",
    fontSize: "12px",
    fontWeight: "bold",
  }}
>
  <Typography variant="body2">Rows: {data ? data.length : 0}</Typography>
  <Typography variant="body2">Total Price: {totalPrice.toLocaleString()}$</Typography>
</Box>



</Paper> 
       </Box>
  );
        
}
